import type en from "../en/ui";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  optional: "(facultatif)",
  breadcrumb: "Fil d’Ariane",
  tabs: "Onglets",
  pagination: "Pagination",
  results: "{count} résultats",
  results_one: "{count} résultat",
  pageSummary: "Page {page} sur {pages} · {total} résultats",
  working: "Traitement…",
  reason: "Motif",
  uploadFailed: "Échec de l’envoi",
  uploadHintPrivate: "PDF, ZIP, EPUB, MP3 ou MP4 jusqu’à 100 Mo — stockage privé",
  uploadHintPublic: "PNG, JPEG, WebP, GIF ou AVIF jusqu’à 10 Mo",
  status_active: "Actif",
  status_inactive: "Inactif",
  status_published: "Publié",
  status_paid: "Payé",
  status_unpaid: "Impayé",
  status_partially_paid: "Partiellement payé",
  status_captured: "Encaissé",
  status_fulfilled: "Expédié",
  status_unfulfilled: "Non expédié",
  status_partially_fulfilled: "Partiellement expédié",
  status_succeeded: "Réussi",
  status_connected: "Connecté",
  status_disconnected: "Déconnecté",
  status_verified: "Vérifié",
  status_completed: "Terminé",
  status_complete: "Complet",
  status_delivered: "Livré",
  status_approved: "Approuvé",
  status_refunded: "Remboursé",
  status_partially_refunded: "Partiellement remboursé",
  status_draft: "Brouillon",
  status_archived: "Archivé",
  status_cancelled: "Annulé",
  status_canceled: "Annulé",
  status_closed: "Fermé",
  status_not_required: "Non requis",
  status_expired: "Expiré",
  status_pending: "En attente",
  status_awaiting_action: "Action requise",
  status_awaiting_confirmation: "En attente de confirmation",
  status_requested: "Demandé",
  status_setup_required: "Configuration requise",
  status_open: "Ouvert",
  status_resolved: "Résolu",
  status_in_progress: "En cours",
  status_authorized: "Autorisé",
  status_received: "Reçu",
  status_processed: "Traité",
  status_processing: "En traitement",
  status_ignored: "Ignoré",
  status_trialing: "Essai",
  status_shipped: "Expédié",
  status_failed: "Échec",
  status_error: "Erreur",
  status_disputed: "Contesté",
  status_suspended: "Suspendu",
  status_rejected: "Refusé",
  status_reauth_required: "Reconnexion requise",
  status_past_due: "Paiement en retard",
  status_incomplete: "Incomplet",
  status_chargeback: "Rétrofacturation",
  status_urgent: "Urgent",
  status_high: "Élevée",
  status_normal: "Normale",
  status_low: "Faible",
  status_void: "Annulée",
  status_uncollectible: "Irrécouvrable",
  status_queued: "En file d’attente",
  status_running: "En cours",
  status_done: "Terminé",
  status_sent: "Envoyé",
  status_logged: "Journalisé",
  status_suppressed: "Bloqué",
  status_unknown: "Inconnu",
  status_converted: "Converti",
  status_missing: "Manquant",
  status_partial: "Partiel",
  status_outdated: "Obsolète",
  status_undone: "Annulé",
  status_scheduled: "Planifié",
};

export default fr;
